<signering-status [signatarer]="signatarer()" [status]="dokumentversjon().signeringStatus" />

<tittel-verdi tittel="{{'Tillatte signeringsmåter'|translate}}" class="signeringsmåter">
  <verdi>
    <ul>
      @if (enkelSignaturmetodeTilgjengelig()) {
        <li>
          <div data-testid="signaturmetode">{{ 'Enkel elektronisk'|translate }}</div>
          <div class="beskrivelse">{{ 'Bruker signerer med et engangspassord tilsendt på SMS eller e-post'|translate }}</div>
        </li>
      }
      @if (avansertSignaturmetodeTilgjengelig()) {
        <li>
          <div data-testid="signaturmetode">{{ 'Avansert elektronisk'|translate }}</div>
          <div class="beskrivelse">{{ 'Bruker signerer med BankID'|translate }}</div>
        </li>
      }
    </ul>
  </verdi>
</tittel-verdi>

<div class="handlinger">
  @if (redigerMulig()) {
    <button mat-stroked-button color="primary" (click)="rediger()" matTooltip="{{'Du kan endre hvem som skal signere samt signeringsmåte frem til alle har signert'|translate}}">
      {{ 'Rediger'|translate }}
    </button>
  }
  @if (avsluttMulig()) {
    <button mat-stroked-button (click)="avsluttSignering()"
            matTooltip="{{'Markerer dokumentet som ferdig signert og generer teknisk/juridisk signaturinformasjon'|translate}}">
      {{ 'Avslutt'|translate }}
    </button>
  }
  @if (kansellerMulig()) {
    <button mat-stroked-button color="warn" (klikk)="kansellerSignering()" [bekreftKlikk]="'Ja, slett alle signaturer'|translate"
            matTooltip="{{'Sletter eventuelle registrerte signaturer og gjør det mulig å registrere nye versjoner av dokumentet'|translate}}">
      {{ 'Kanseller'|translate }}
    </button>
  }
</div>
